export const STEP_WIDTH = 200
export const INSERT_ZONE_WIDTH = 28
export const CARD_HEIGHT = 92
